import "./index.css";

import {
  Grid,
  Row,
  Typography,
  theme
} from "antd";
import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { api } from "../../../services/api";
import CardCourse from "./CardCourse";

const { useToken } = theme;
const { useBreakpoint } = Grid;

const Courses = () => {
  const { token } = useToken();
  const screens = useBreakpoint();

  const [coursesConcluded, setCoursesConcluded] = useState([]);
  const [coursesProgress, setCoursesProgress] = useState([]);

  const getCourses = async () => {
    await api.get(`/panel/student-dashboard`)
      .then((res) => {
        setCoursesProgress(
          res?.data?.data?.courses_info?.filter((enroll, i) => {
            if (enroll.course_completion != 1 && enroll.active == 1){
              return enroll;
            }
          })
        );

        setCoursesConcluded(
          res?.data?.data?.courses_info?.filter((enroll, i) => {
            if (enroll.course_completion == 1 && enroll.active == 1) {
              return enroll;
            }
          })
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCourses();
  }, []);
  return (
    <div >
      <Row justify="space-between" align="top" style={{ marginBottom: "14px" }}>
        <Typography className="title-header">
          Meus cursos em andamento
        </Typography>
      </Row>

      <Row gutter={[28, 26]} style={{ marginBottom: "41px", marginLeft: 0, marginRight: 0 }}>
        {coursesProgress.map((el, i) => (
          <>
            <CardCourse percent={el.course_completion * 100} courses={el} />
          </>

        ))}
      </Row>

      <Row style={{ marginBottom: "31px", }} align='middle' justify='space-between'>
        <Typography className="title-header">Cursos concluídos</Typography>
        <Link to='/' style={{ display: coursesConcluded.length == 0 ? 'none' : 'block' }}>
          <Typography className="all">Ver todos</Typography>
        </Link>
      </Row>
      <Row gutter={[10, 10]}>
        {coursesConcluded.length > 0 ? (
          coursesConcluded.map((el, i) => (
            <>
              <CardCourse courses={el} key={i} />
            </>
          ))
        ) : (
          <>Nenhum curso concluído</>
        )}
      </Row>
    </div>
  );
};

export default Courses;
